import React from 'react';
import { SVGComponentProps } from 'modules/core/components/layout/svg/index';

export const LocationSVG: React.FC<SVGComponentProps> = ({ className }: SVGComponentProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5" className={className}>
    <g transform="translate(0.75 0.75)">
    <path d="M12,3V21M3,12H21m-2,0a7,7,0,1,1-7-7A7,7,0,0,1,19,12Z" transform="translate(-3 -3)"/>
    </g>
  </svg>
);